"use client";

import { useState } from "react";
import SubNavigation, { BreakpointConfig } from "./SubNavigation";

export interface SubNavigationItem {
  id: number;
  label: string;
  href?: string;
  target?: string;
}

interface ProfileSubNavProps {
  title: string;
  items: SubNavigationItem[];
  defaultActiveId?: number;
  itemsPerBreakpoint?: BreakpointConfig;
}

const ProfileSubNav = ({
  title,
  items,
  defaultActiveId = 1,
  itemsPerBreakpoint,
}: ProfileSubNavProps) => {
  const [activeItem, setActiveItem] = useState<number>(defaultActiveId);

  return (
    <SubNavigation
      title={title}
      items={items}
      activeItem={activeItem}
      onItemClick={setActiveItem}
      itemsPerBreakpoint={itemsPerBreakpoint}
    />
  );
};

export default ProfileSubNav;
